import React from 'react';
import { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FacebookShareButton, TwitterShareButton } from 'react-share';
import { Helmet } from 'react-helmet-async';
import {MeriaInner} from './MeriaInner';
import { getMeri } from '../service/service';
import { useContext } from 'react';
import { SearchContext } from './Contexts/Context';
function MeriaMeri() {
	const { language } = useContext(SearchContext);
	const navigate = useNavigate();

	const [loading, setLoading] = useState(true);
	const [width, setWidth] = useState(10);
	const ref = useRef(null);
	const [meri, setMeri] = useState([]);

	

	useEffect(() => {
		  const getMeriFc = async () => {
			try {
			  const data = await getMeri();
			  setMeri(data);
			  setLoading(false);
			  console.log('meris moadgileebi', data);
			} catch (error) {
			  console.error('Error fetching meris moadgileebi:', error);
			  setLoading(true);
			}
		  };
		  getMeriFc();
		}, []);
				
	return (
		<motion.div
			intial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			<Helmet>
				<title>მერი</title>
			</Helmet>
			<div className='news-container margin-280px'>
				{loading ? (
					"Loading..."
				) : (
					<MeriaInner data={meri[0]} />
				)}
			</div>
			{/* {memberie} */}
	
		</motion.div>
	);
}

export default MeriaMeri;
